<template>
	<div>
		<div id="background" v-bind:class="`tab-type-${tabType}`">
			<div id="overlay-modal-container">
				<div id="overlay-modal-content">
					<div id="close" v-on:click="closeOverlay([content[which].columnButtonAction,false])">
						<img width="24" src="../assets/global/close-button-alt.png" alt="close" />
					</div>
					<slot></slot>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		which: {
			type: String
		},
		tabType: {
			type: String
		},
		content: {
			type: Object
		},
	},
	methods: {
		closeOverlay(whichActions){
			this.$emit('show-overlay',whichActions)
		}
	},
}
</script>

<style scoped>
#background {
	background-color: rgba(228,231,234,.51);
	display: flex;
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
}

#close {
	cursor: pointer;
	padding: 9px;
	position: absolute;
	top: 15px;
	right: 30px;
}

#overlay-modal-container {
	display: grid;
	place-items: center;
	width: 100%;
	height: 100%;
}

	#overlay-modal-content {
		position: relative;
	}

		.tab-type-diagnosis #overlay-modal-content {
			margin-bottom: 75px;
		}

		#overlay-modal img.om-single-img {
			margin: 0 auto;
			text-align: center;
		}
</style>